module.exports = __webpack_public_path__ + "images/category_lp/retro_game/store_images/4_ba693aa55f9249e9af371cb0f0d8c5e1.png";